import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import { Button } from "../../ui/button";
import BankDetailtable from "./BankDetailtable";
import { useLocation } from "react-router-dom";
import {
  fetchBankDetails,
  addBankDetails,
  setIsVisible,
  clearDataFetched,
  setDisableBtn,
  setPersistedFormData,
} from "./BankDetailSlice";
import { useDispatch } from "react-redux";
import ButtonGroup from "../Common/Buttons/ButtonGroup";
import Input from "../Common/inputs/Input";
import { BankDetailsData, bankErrors } from "../Common/data/mapData";
import Skelton from "../Common/skeleton/Skeleton";
import { getRolePermission, getUserRolePermissionV2 } from "../CreatePermission/CreatePermissionSlice";

const BankDetails = (props) => {
  const isAccountVisible = useSelector(
    (state) => state.dashboard.isAccountVisible
  );
  
  const userRolePermissionList = useSelector(
    (state) => state.createPermission.userRolePermissionList
  );
  
  // Restores the form after switching tabs away and back (this page fully
  // unmounts/remounts on tab switch) - read once here and used only as lazy
  // useState initializers below, so the very first render already matches.
  const persistedFormData = useSelector((state) => state.bankDetails.persistedFormData) || {};

  const [bankName, setBankName] = useState(() => persistedFormData.bankName ?? "");
  const [accountHolder, setAccountHolder] = useState(() => persistedFormData.accountHolder ?? "");
  const [branchName, setBranchName] = useState(() => persistedFormData.branchName ?? "");
  const [accntNo, setAccntNo] = useState(() => persistedFormData.accntNo ?? "");
  const [ifscCode, setIfScCode] = useState(() => persistedFormData.ifscCode ?? "");
  const [error, setError] = useState([]);
  const [disableBtn, setDisablebtn] = useState(false);
  const [showAddBankButton, setShowAddBankButton] = useState(false); 
  
  const dispatch = useDispatch();
  const location = useLocation();
  const id = props.userId ? props.userId : localStorage.getItem("userId");
  const [isBetCorrectBrand, setIsBetCorrectBrand] = useState(false);

  const permissions = [
    "ADD_BANK_CHECK",
  ];

  const checkBrandName = () => {
    const currentBrandId = localStorage.getItem("brandId");
    if (currentBrandId === "268") {
      setIsBetCorrectBrand(true);
    } else {
      setIsBetCorrectBrand(false);
    }
  };

  const checkBankRole = () => {
    if (userRolePermissionList && userRolePermissionList.length > 0) {
      if (isBetCorrectBrand) {
        const hasRequiredRole = userRolePermissionList.some(permission => 
          permissions.includes(permission.permissionName)
        );
        setShowAddBankButton(hasRequiredRole);
      } else {
        setShowAddBankButton(true);
      }
    } else if (!isBetCorrectBrand) {
      setShowAddBankButton(true);
    }
  };

  useEffect(() => {
    let mounting = true;
    if (mounting) {
      checkBrandName();
     // dispatch(getRolePermission());
     //dispatch(getUserRolePermissionV2());
    }
    return () => (mounting = false);
  }, [dispatch]);

  useEffect(() => {
    checkBankRole();
  }, [userRolePermissionList, isBetCorrectBrand]); 

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "accountHolderName") {
      setAccountHolder(value);
      setError(error.filter((item) => item !== name));
    }
    if (name === "bankName") {
      setBankName(value);
      setError(error.filter((item) => item !== name));
    }
    if (name === "branchName") {
      setBranchName(value);
      setError(error.filter((item) => item !== name));
    }
    if (name === "accountNumber") {
      setAccntNo(value);
      setError(error.filter((item) => item !== name));
    }
    if (name === "ifscCode") {
      setIfScCode(value);
      setError(error.filter((item) => item !== name));
    }
  };

  const submitDetails = (e) => {
    e.preventDefault();
    if (
      bankName !== "" &&
      branchName !== "" &&
      accntNo !== "" &&
      accountHolder !== ""
    ) {
      const bank = {
        accountHolderName: accountHolder,
        bankName: bankName,
        branchName: branchName,
        accntNo: accntNo,
        ifscCode: ifscCode,
      };
      dispatch(addBankDetails(bank, id));
      setDisablebtn(true);
    } else {
      setError(bankErrors);
    }
  };

  const resetDetails = () => {
    setBankName("");
    setBranchName("");
    setAccntNo("");
    setIfScCode("");
    setAccountHolder("");
    setError([]);
  };

  useEffect(() => {
    let mounting = true;
    if (mounting) {
      dispatch(fetchBankDetails({ id: localStorage.getItem("userId") }));
    }
    return () => (mounting = false);
  }, []);

  useEffect(() => {
    const userID = location.pathname.split("/")[2];
    if (props.userId !== userID) {
      dispatch(fetchBankDetails({ id: userID }));
      dispatch(setIsVisible(false));
    }
  }, [location]);

  useEffect(() => {
    if (props.dataFetched) {
      dispatch(clearDataFetched(false));
      resetDetails();
    }
  }, [props.dataFetched]);

  useEffect(() => {
    if (props.disableBtn) {
      setTimeout(() => {
        dispatch(setDisableBtn(false));
        setDisablebtn(false);
      }, 3000);
    }
  }, [props.disableBtn]);

  // Mirrors the persistable form fields into redux on every change, so they
  // survive this page unmounting/remounting on tab switch.
  useEffect(() => {
    dispatch(setPersistedFormData({ bankName, accountHolder, branchName, accntNo, ifscCode }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bankName, accountHolder, branchName, accntNo, ifscCode]);

  return (
    <>
      <div className="flex flex-col gap-4">
          <div className="rounded-lg border bg-card p-6">
            <div className="mb-6">
              <h2 className="text-lg font-semibold text-foreground">Bank Details</h2>
              <p className="text-sm text-muted-foreground mt-1">Add or manage your bank account information</p>
            </div>
            <div className="space-y-4">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
                {BankDetailsData.map((item, ind) => {
                  const values = [
                    accountHolder,
                    bankName,
                    branchName,
                    accntNo,
                    ifscCode,
                  ];
                  return (
                    <div key={item.id}>
                      <Input
                        title={item.title}
                        name={item.name}
                        ids={item.ids}
                        value={values[ind]}
                        placeholder={item.placeholder}
                        setValue={handleChange}
                        errorMsg={error.includes(item.name) && item.errorMsg}
                        info={item.info}
                        show={true}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
            
            <div className="flex justify-end gap-3 pt-6 border-t mt-6">
              <Button
                id="bankreset"
                onClick={(e) => resetDetails(e)}
                variant="outline"
                type="reset"
              >
                Reset
              </Button>
              {showAddBankButton ? (
                <Button
                  id="addBank"
                  variant="default"
                  onClick={(e) => submitDetails(e)}
                  disabled={disableBtn || props.viewOnlyuser}
                >
                  Add Bank
                </Button>
              ) : null}
            </div>
          </div>

          {!props.isVisible ? (
            <Skelton />
          ) : (
            <BankDetailtable
              data={props.bankDetails}
              masking={isAccountVisible}
            />
          )}
      </div>
    </>
  );
};

function mapStateToProps(state) {
  return {
    bankDetails: state.bankDetails.bankData,
    userId: state.playersearch.userId,
    isVisible: state.bankDetails.isVisible,
    dataFetched: state.bankDetails.dataFetched,
    disableBtn: state.bankDetails.disableBtn,
    isAccountVisible: state.dashboard.isAccountVisible,
    viewOnlyuser: state.dashboard.viewOnlyuser,
  //  permissionList: state.createPermission.permissionList,
    userRolePermissionList: state.createPermission.userRolePermissionList,
  };
}

export default connect(mapStateToProps)(BankDetails);